import { Component, Input, OnInit } from '@angular/core';
import * as Chart from 'chart.js'

@Component({
  selector: 'app-chart-line',
  templateUrl: './chart-line.component.html',
  styleUrls: ['./chart-line.component.css']
})
export class ChartLineComponent implements OnInit {
  @Input('id') id : any;
  @Input('type') type : any;
  @Input('idCanvas') idCanvas : any;
  @Input('labelY') labelY : any;
  @Input('labelUnd') labelUnd : any;
  @Input('labelValueMin') labelValueMin : any;
  @Input('labelValueMax') labelValueMax : any;
  @Input('lineValueMin') lineValueMin : any;
  @Input('lineValueMax') lineValueMax : any;
  @Input('labelChart') labelChart : any;
  @Input('labelsChart') labelsChart : any;
  @Input('valuesChart') valuesChart : any;
  @Input('colorArray') colorArray : any;
  @Input('optionFilter') optionFilter : any;
  @Input('showroom') showroom : any;

  public chart: any;
  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    console.log("Chart component inputs:", {
      lineValueMin: this.lineValueMin,
      lineValueMax: this.lineValueMax,
      valuesChart: this.valuesChart
    });
    
    const labels = this.labelsChart;
    const arrayData = this.valuesChart;
    
    // Crear estructura de datos usando los datos reales
    var data;
    if(this.showroom == "1"){
      data = {
        labels: labels,
        datasets: [
          {
            data: arrayData,
            borderColor: function(context) {
              const chart = context.chart;
              const {ctx, chartArea} = chart;

              if (!chartArea) {
                return;
              }
              return getGradient(ctx, chartArea);
            },
          },
        ]
      };
    }else{
      console.log("labels",labels);
      console.log("arrayData",arrayData)
      data = {
        labels:labels,
        datasets: arrayData
      };
      console.log("data line",data);
    }

    let width, height, gradient;
    function getGradient(ctx, chartArea) {
      const chartWidth = chartArea.right - chartArea.left;
      const chartHeight = chartArea.bottom - chartArea.top;
      if (!gradient || width !== chartWidth || height !== chartHeight) {
        // Create the gradient because this is either the first render
        // or the size of the chart has changed
        width = chartWidth;
        height = chartHeight;
        gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
        gradient.addColorStop(0, 'blue');
        gradient.addColorStop(0.5, 'yellow');
        gradient.addColorStop(1, 'red');
      }

      return gradient;
    }

    // Configuración del eje Y usando los valores pasados como parámetros
    let valueY: any = {
      beginAtZero: true
    };
    
    // Usar los valores min/max que se pasan como parámetros
    if (this.labelValueMin !== null && this.labelValueMin !== undefined && this.labelValueMin !== "") {
      valueY.min = parseFloat(this.labelValueMin);
    } else {
      valueY.min = -3; // Valor por defecto
    }
    
    if (this.labelValueMax !== null && this.labelValueMax !== undefined && this.labelValueMax !== "") {
      valueY.max = parseFloat(this.labelValueMax);
    } else {
      valueY.max = 7; // Valor por defecto
    }
    
    console.log("Y-axis range configured:", valueY);
    console.log("Input values - labelValueMin:", this.labelValueMin, "labelValueMax:", this.labelValueMax);
    
    // Agregar líneas horizontales para min/max usando los datos reales
    if (this.lineValueMin && Array.isArray(this.lineValueMin) && data.datasets && data.labels) {
      this.lineValueMin.forEach(dataset => {
        if (dataset && dataset.minValue !== null && dataset.minValue !== undefined) {
          const minValue = parseFloat(dataset.minValue);
          if (!isNaN(minValue)) {
            const minLineData = data.labels.map(() => minValue);
            console.log("Adding min line with value:", minValue, "from dataset:", dataset.label);
            data.datasets.push({
              label: `Min: ${minValue}`,
              data: minLineData,
              borderColor: 'red',
              backgroundColor: 'transparent',
              borderWidth: 2,
              borderDash: [5, 5],
              pointRadius: 0,
              fill: false,
              type: 'line'
            });
          }
        }
      });
    }
    
    if (this.lineValueMax && Array.isArray(this.lineValueMax) && data.datasets && data.labels) {
      this.lineValueMax.forEach(dataset => {
        if (dataset && dataset.maxValue !== null && dataset.maxValue !== undefined) {
          const maxValue = parseFloat(dataset.maxValue);
          if (!isNaN(maxValue)) {
            const maxLineData = data.labels.map(() => maxValue);
            console.log("Adding max line with value:", maxValue, "from dataset:", dataset.label);
            data.datasets.push({
              label: `Max: ${maxValue}`,
              data: maxLineData,
              borderColor: 'green',
              backgroundColor: 'transparent',
              borderWidth: 2,
              borderDash: [5, 5],
              pointRadius: 0,
              fill: false,
              type: 'line'
            });
          }
        }
      });
    }

    this.chart = new Chart('chartLine'+this.idCanvas,{
      type: 'line',
      data: data,
      options:{
        responsive: true,
        maintainAspectRatio: false,
                 scales: {
           y: {
             min: valueY.min,
             max: valueY.max,
             beginAtZero: valueY.beginAtZero,
             title: {
               display: true,
               text: this.labelY + " ("+this.labelUnd+")"
             }
           },
          x: {
            title: {
              display: true,
              text: 'Tiempo'
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'top'
          }
        }
      }
    });
  }
}
